import React, { useEffect } from 'react';
import Footer from '../../../components/Footer/Footer';
import SimpleHeader from '../../../components/Header/simpleHeader';
import failedIcon from '../../../Assets/images/Activation/failed.svg';
import call from '../../../Assets/images/Activation/Shape.svg';
import BannerImg from '../../../Assets/images/Activation/activationBanner.webp';
import BannerIpadImg from '../../../Assets/images/Activation/activationBannerIPad.webp';
import { globalVal } from '../../../global/globalvalues';
import Button from '../../../components/Button/Button';
import './Activation.scss';

type initialProps = {
    history: any;
};
const ActivationError = (props: initialProps) => {
    useEffect(() => {
        window.scroll(0, 0);
    }, []);
    return (
        <div className="activationError">
            <SimpleHeader history={props.history} isHelp={true} />
            <div className="bannerImg">
                <img src={BannerImg} alt="img" className="WebImg" />
                <img src={BannerIpadImg} alt="img" className="IpadImg" />
                <div className="contentCarousel">
                    <div className="Goodbye-mobile-store">Activation</div>
                </div>
            </div>
            <div className="activationErrorCont">
                <img src={failedIcon} />
                <div className="title">Activation Not Yet Available</div>
                <div className="subtitle">
                    {globalVal?.short_name} home internet service must be installed and active before activating{' '}
                    {globalVal?.long_name} services. If your home internet service is installed and active, please reach
                    out to our Care Team for assistance.
                </div>
                <div className="call">
                    <img src={call} alt="phone" />
                    <span className="contactNumber">CALL 1.800.427.8686</span>
                </div>
            </div>
            <div className="backCTA">
                <Button primary={true} onClick={() => props.history.push('/post-activation-home')}>
                    GO TO HOME
                </Button>
            </div>
            <Footer isFixed={true} />
        </div>
    );
};
export default ActivationError;
